import React from 'react'
import { Link } from 'gatsby'
import { css } from '@emotion/react'
import externalLink from '../images/svgs/external-link-white.svg'

const labelStyle = theme => css({
    fontFamily: theme.fonts.secondary,
    fontSize: 13,
    fontWeight: 700,
    marginBottom: 24,
})

const gridStyle = theme => css({
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 20,
    borderBottom: `1px solid ${theme.colors.mutedDark}`,
    paddingBottom: 24,
    marginBottom: 24,
})

const externalStyle = { 
    display: 'flex',
    gap: 8
}

export const ExternalLink = () => <img src={externalLink} alt='external link' />

export const SupportLinks = (props) => <>
    <a href='https://forum.moogmusic.com/' target='_blank' rel='noreferrer' css={externalStyle} {...props}>
        Forum
        <ExternalLink />
    </a>
    <a href='https://moogmusic-help.freshdesk.com/' target='_blank' rel='noreferrer' css={externalStyle} {...props}>
        Helpdesk
        <ExternalLink />
    </a>
    <a href='https://moogmusic-help.freshdesk.com/en/support/solutions' target='_blank' rel='noreferrer' css={externalStyle} {...props}>
        Knowledge base
        <ExternalLink />
    </a>
</>

export const DownloadLinks = (props) => <>
    <Link to='/downloads' {...props}>All Product Downloads</Link>
    <Link to={`${encodeURI('/downloads?type=Preset')}`} {...props}>Presets</Link>
    <Link to={`${encodeURI('/downloads?type=User Manual')}`} {...props}>User Manuals</Link>
    <Link to={`${encodeURI('/downloads?type=Patch')}`} {...props}>Patches</Link>
    <Link to={`${encodeURI('/downloads?type=Firmware Update')}`} {...props}>Firmware Updates</Link>
</>

export default function NavSupport() {
    return <>
        <h6 css={labelStyle}>Support</h6>
        <div css={gridStyle}><SupportLinks /></div>
        <h6 css={labelStyle}>Downloads</h6>
        <div css={gridStyle}><DownloadLinks /></div>
    </>
}
